import { Component, EventEmitter, inject, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverlayBadgeModule } from "primeng/overlaybadge";
import { AngularSvgIconModule } from "angular-svg-icon";
import { LoggerService } from "../../../ancestors/logger.service";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { NotificationStateService } from "../../services/state/notification-state.service";

/**
 * Componente bottone notifiche con badge per l'header
 * Mostra un'icona campana con badge che indica il numero di notifiche non lette.
 * Emette un evento per aprire il sidenav delle notifiche.
 */
@Component({
  selector: "ape-header-notification-button",
  standalone: true,
  imports: [
    CommonModule, OverlayBadgeModule, AngularSvgIconModule, TranslatePipe
  ],
  templateUrl: "./ape-header-notification-button.component.html"
})
export class ApeHeaderNotificationButtonComponent {
  /**
   * Chiavi di traduzione per type safety
   */
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private logger = inject(LoggerService);

  private notificationState = inject(NotificationStateService);

  /**
   * Observable per il coFnteggio delle notifiche non lette
   */
  unreadCount$ = this.notificationState.unreadCount$;

  /**
   * Evento emesso quando il bottone viene cliccato per aprire il sidenav
   */
  @Output() openSidenav = new EventEmitter<void>();

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  /**
   * Gestisce il click sul bottone notifiche
   * Emette un evento per aprire il sidenav delle notifiche
   */
  onNotificationClick(): void {
    this.logger.info("Notification button clicked - opening sidenav");
    this.openSidenav.emit();
  }

  /**
   * Determina se mostrare il badge
   * @returns true se ci sono notifiche non lette
   */
  get shouldShowBadge(): boolean {
    return this.notificationState.unreadCount > 0;
  }

  /**
   * Ottiene il valore da mostrare nel badge
   * @returns Numero di notifiche o "99+" se supera 99
   */
  get badgeValue(): string {
    const count = this.notificationState.unreadCount;
    if (count > 99) {
      return "99+";
    }
    return count.toString();
  }
}
